export default __webpack_public_path__ + "static/media/mobile_tc1_En.0c2d8d69.webp";